export enum DataSensitivityLevelId {
	None = 1,
	Public,
	Internal,
	Confidential,
	Restricted,
	MissionCritical
}
